import {useTranslation} from 'react-i18next';
import './ArrivalDetails.scss';
import {QrComponent} from './qr/QrComponent';
import {ArrivalPopupAction, ModalContainer} from './modalContainer/ModalContainer';
import {PickSiteLanguage} from '../main/components/PickSiteLanguage';
import {useEffect, useState} from 'react';
import {DataActions, useArrivalContext} from 'src/context/ArrivalContext';
import {DropInQueueResponse} from '../../services/api/types/types';
import {fetchDropInQueueOverview} from '../../services/api/api';
import {RefreshIcon} from 'src/components/icons/RefreshIcon';

export function ArrivalDetails() {
    const {t} = useTranslation();

    const {dispatch, dataState} = useArrivalContext();

    const [popupAction, setPopupAction] = useState<ArrivalPopupAction | undefined>(undefined);

    useEffect(() => {
        if (dataState.settings) {
            document.title = t('route_name.arrival', {clinicName: dataState.settings.name});
        }
    }, [dataState, t]);

    if (dataState.loading) return <></>;
    if (dataState.error || (!dataState.settings?.bookingEnabled && !dataState.settings?.dropinEnabled)) {
        return (
            <div className='arrival-container'>
                <div className='arrival-container__text'>
                    <h1 className='arrival-container__heading'>{t(`arrival.heading_notfound`)}</h1>
                </div>
            </div>
        );
    }

    const refreshPage = () => {
        window.location.reload();
    };

    return (
        <>
            <ModalContainer
                popup={popupAction}
                onClose={() => {
                    dispatch({type: DataActions.SET_STEP, value: 'initial'});
                    dispatch({type: DataActions.SET_PEOPLE, value: []});
                    dispatch({
                        type: DataActions.SET_REASON_DATA,
                        value: {
                            category: null,
                            numberPatients: null,
                            appointmentType: null,
                            healthDeclarationDefinitionId: null,
                            allowedAge: null
                        }
                    });
                    setPopupAction(undefined);
                }}
            />

            <div className='arrival-container__top'>
                <div>
                    {dataState.settings?.logoUrl && (
                        <img src={dataState.settings?.logoUrl} height='32' alt={`${dataState.settings?.name} logo`} />
                    )}
                    {dataState.settings?.name && <>{dataState.settings?.name}</>}
                </div>
                <div className='arrival-controls'>
                    <button
                        type='button'
                        className='arrival-refresh-button'
                        onClick={refreshPage}
                        aria-label={t('general.refresh_page')}
                        title={t('general.refresh_page')}
                    >
                        <RefreshIcon />
                    </button>
                    <div className='arrival-language'>
                        <PickSiteLanguage size='big' />
                    </div>
                </div>
            </div>
            <div className='arrival-container__text'>
                <div className='arrival-container__text__inner'>
                    <h1 className='arrival-container__text__inner__heading'>{t(`arrival.heading`)}</h1>
                    {dataState.settings?.welcomeText && dataState.settings?.welcomeText.length > 0 ? (
                        <p className='wrap-html'>{dataState.settings?.welcomeText}</p>
                    ) : (
                        ''
                    )}
                    <p
                        className='arrival-container__text__inner__paragraph'
                        dangerouslySetInnerHTML={{__html: t('arrival.scan_qr_text')}}
                    />
                </div>
            </div>
            <div className='arrival-container__qr'>
                {dataState.settings?.bookingEnabled ? (
                    <QrComponent
                        target='booking'
                        clinicId={dataState.clinicId}
                        onAction={() => setPopupAction('booking')}
                        canOpenModalFlow={dataState.settings.public}
                    />
                ) : (
                    ''
                )}
                {dataState.settings?.dropinEnabled ? (
                    <QrComponent
                        target='dropin'
                        clinicId={dataState.clinicId}
                        onAction={() => setPopupAction('dropin')}
                        canOpenModalFlow={dataState.settings.public}
                    />
                ) : (
                    ''
                )}
            </div>
        </>
    );
}
